import * as React from "react";
const SvgGlobe20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10.85 9.15V3.156c.405.286.828.788 1.218 1.567.564 1.128.96 2.671 1.058 4.427H10.85Zm-1.7 0V3.156c-.405.286-.829.788-1.218 1.567-.564 1.128-.96 2.671-1.059 4.427H9.15Zm-2.277 1.7H9.15v5.994c-.405-.286-.829-.788-1.218-1.567-.564-1.128-.96-2.671-1.059-4.427Zm-1.702-1.7C5.27 7.184 5.707 5.387 6.393 4a7.002 7.002 0 0 0-3.342 5.15h2.12Zm-2.12 1.7h2.12c.099 1.966.536 3.763 1.222 5.15a7.002 7.002 0 0 1-3.342-5.15Zm7.799 0h2.276c-.098 1.756-.494 3.299-1.058 4.427-.39.78-.813 1.281-1.218 1.567V10.85Zm3.979 0c-.099 1.966-.537 3.763-1.222 5.15a7.002 7.002 0 0 0 3.342-5.15h-2.12Zm2.12-1.7A7.002 7.002 0 0 0 13.607 4c.685 1.387 1.123 3.184 1.222 5.15h2.12ZM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z",
      clipRule: "evenodd"
    })
  );
export default SvgGlobe20Px;
